import { StdResponse, request } from "@/global/config/request";
import { Warning } from "@/global/interface/monitoring/warning";

export function getWarnings(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/warnings`, {
        params: {
            ...params,
        }
    })
}

export function getWarningCount(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/warning-count`, {
        params: {
            ...params,
        }
    })
}

export function updateWarning(id: number, data: Warning, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/warnings/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function getRecentWarningByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/warnings/recent`, {
        params: {
            ...params,
        }
    })
}